<template>
  <div>
    <van-nav-bar :title="title" style="position:fixed;width: 100%;"  >
    </van-nav-bar>

   <!--  <div  style="padding-top: 45px">
       </div> -->
         <van-row style="padding: 50px;background-color: white;">{{title}}</van-row>
    <van-cell-group>
      <van-field
          v-model="form.username"
          label="姓名"
          placeholder="输入姓名"
          required
          clearable
          :label-width="100"
        />
        <van-field
            v-model="form.workspace"
            label="单位"
            placeholder="输入您的单位"
            required
            clearable
            :label-width="100"
          />
          <van-field
              v-model="form.zhichen"
              label="职称"
              placeholder="输入您的职称"
              required
              clearable
              :label-width="100"
            />
            <van-field
                v-model="form.zhuanye"
                label="专业"
                placeholder="输入您的专业"

                clearable
                :label-width="100"
              />
            <van-field
                v-model="form.mobile"
                label="电话"
                placeholder="输入您的电话"
                required
                clearable
                :label-width="100"
              />
    </van-cell-group>
    <div style="background-color: white;height: 800px;"></div>
    <van-tabbar  active-color="#ff0000" style="color: bisque;">
      <van-tabbar-item icon="share"  @click="tijiao">提交</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'simpleform',
  data () {
    return {

      id: 0,
      title: '',
      titlelist: ['湖南华地聚鑫矿业有限公司娄底市新化县周家矿区建筑石料用灰岩矿露天开采工程安全设施设计评审参加人员签到表',
        '湖南华地聚鑫矿业有限公司娄底市新化县周家矿区建筑石料用灰岩矿露天开采工程安全设施设计评审参加人员签到表',
        '湖南华地聚鑫矿业有限公司娄底市新化县周家矿区建筑石料用灰岩矿露天开采工程安全设施设计评审专家签字表'],
      form: {}
    }
  },
  created () {
    // const id  = this.$route.params && this.$route.params.bzId;
    let code = this.GetParam(window.location.href, 'id')
    console.log('this.code:', window.location.href, code)
    this.id = code
    this.title = this.titlelist[code]
  },
  activated () {

  },
  methods: {

    GetParam (url, code) {
      url = url + ''
      let regstr = '/(\\?|\\&)' + code + '=([^\\&]+)/'
      let reg = eval(regstr)
      // eval可以将 regstr字符串转换为 正则表达式
      let result = url.match(reg)
      if (result && result[2]) {
        return result[2].replace('#/', '')
      }
    },
    tijiao () {
      // console.log(this.rbdatalist)

      let that = this
      this.form.typeid = this.id
      this.form.ms = this.title
      this.$ajax.post('/nologin/qianming', this.form).then(function (res) {
        if (res.code == 200) {
          that.$toast.success('签名完成！')
          // that.$router.push({path: '/work'})
          // that.$router.go(-1)
          // that.bzdata=res.data
          //  that.rbdatalist=that.zzdata(res.data.rbTbxxqList);
        }
      })
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/SimpleForm/index.vue